import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import Model from 'flarum/common/Model';
export default class Category extends Model {
  constructor() {
    super(...arguments);
    _defineProperty(this, "name", Model.attribute('name'));
    _defineProperty(this, "slug", Model.attribute('slug'));
    _defineProperty(this, "description", Model.attribute('description'));
    _defineProperty(this, "sortOrder", Model.attribute('sortOrder'));
    _defineProperty(this, "allowOther", Model.attribute('allowOther'));
    _defineProperty(this, "createdAt", Model.attribute('createdAt', Model.transformDate));
    _defineProperty(this, "updatedAt", Model.attribute('updatedAt', Model.transformDate));
    _defineProperty(this, "award", Model.hasOne('award'));
    _defineProperty(this, "nominees", Model.hasMany('nominees'));
    _defineProperty(this, "votes", Model.hasMany('votes'));
    _defineProperty(this, "otherSuggestions", Model.hasMany('otherSuggestions'));
    _defineProperty(this, "nomineeCount", Model.attribute('nomineeCount'));
    _defineProperty(this, "voteCount", Model.attribute('voteCount'));
    _defineProperty(this, "userVoteIds", Model.attribute('userVoteIds'));
    _defineProperty(this, "userPendingSuggestionsCount", Model.attribute('userPendingSuggestionsCount'));
  }
  hasUserVoted() {
    const ids = this.userVoteIds();
    return ids && ids.length > 0;
  }
  getUserVotedNomineeIds() {
    return this.userVoteIds() || [];
  }
}
flarum.reg.add('huseyinfiliz-awards', 'common/models/Category', Category);